exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-h2 {\n  margin: 10px; }\n\n.example-section {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 60px; }\n\n.example-margin {\n  margin: 0 10px; }\n\n.graphMarketPerformance {\n  width: 700px;\n  height: 400px; }\n\n.configGraphMarketPerformance {\n  width: 100%;\n  height: 400px;\n  background-color: #FFFFFF; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-performance/market-performance.component.scss
// module id = ../../../../../src/app/market-level/market-performance/market-performance.component.scss
// module chunks = main